export const Controllers = {
    ControllerAdmin:'ADM/'
}